import { paymentSection } from "./sections/payment.js";
import { regulierungSection } from "./sections/regulierung.js";
import { CLAIM_CURRENCY_INPUT_WIDTH } from "./formDefConstants.js";

export const fdefFormB = {
  formdefinition: [
    {
      control: "stepper",
      name: "schadensmeldung",
      label: "Schadenanzeige - Kfz-Schaden",
      showSubformErrorCount: false,
      cols: "12",
      steps: [
        {
          label: "Vertragsdaten",
          description: "Der Schaden wird für folgenden Vertrag gemeldet.",
          children: [
            {
              control: "input",
              name: "vertragsnummer",
              label: "Vertragsnummer",
              disabled: "true",
              cols: "6",
            },
            {
              control: "input",
              name: "gesellschaft",
              label: "Gesellschaft",
              disabled: "true",
              cols: "6",
            },
          ],
        },
        {
          label: "Schaden",
          description:
            "Die Frage, 'Was ist passiert?', ist entscheidend, um den Versicherungsschaden korrekt zu bearbeiten. Bitte beschreiben Sie den Vorfall so ausführlich wie möglich. Wo und wann ist er passiert? Welche Umstände haben dazu geführt? Welche Schäden sind aufgetreten? Ihre genaue Beschreibung hilft dem Versicherer, den Schadensfall effizient zu prüfen und die Ansprüche Ihres Mandante zu bearbeiten. Je mehr Informationen Sie bereitstellen, desto besser kann der Versicherer Ihren Schaden prüfen.",
          children: [
            {
              control: "switch",
              name: "vorsteuerabzugsberechtigt",
              label: "Vorsteuerabzugsberechtigt",
              cols: 12,
            },
            {
              control: "input",
              name: "schaden_nummer_kd",
              label: "eigene Vorgangsnummer",
              cols: "12",
            },
            {
              control: "datepicker",
              name: "schaden_datum",
              label: "Schadensdatum",
              valid:
                "isNotEmpty(item) && !isBigger(item, new Date(), 'Das Schadensdatum darf nicht in der Zukunft liegen.')",
              cols: "6",
            },
            {
              control: "timepicker",
              name: "schaden_uhrzeit",
              label: "Uhrzeit",
              cols: "6",
            },
            {
              control: "switch",
              name: "grossschaden",
              label: "Großschaden",
              cols: 12,
            },
            {
              control: "textarea",
              name: "schaden_ort",
              label: "Schadenort",
              disabled: "false",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_adresszusatz",
              label: "Adresszusatz",
              cols: "12",
            },
            {
              control: "input",
              name: "schaden_besichtigung_adresse",
              label: "Besichtigung (Adresse)",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_betroffene_sachen",
              label: "Betroffene Sachen (Auflistung)?",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_schilderung",
              label: "Schilderung des Hergangs",
              cols: "12",
              valid: "isNotEmpty(item)",
            },
            {
              control: "autocomplete",
              name: "schaden_ursache", //person.cnation
              label: "Ursache des Schadens",
              valid: "isNotEmpty(item)",
              cols: "12",
              get_api: {
                target: "options",
                method: "get",
                endpoint: "data/schaden_ursachen_select",
              },
            },
            {
              control: "sbwarning",
              betrag: [
                "schaden_rechnungsbetrag",
                "schaden_kostenvoranschlag",
                "schaden_hoehe",
              ],
            },
            {
              control: "numberinput", //immer 0
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "schaden_hoehe",
              label: "Schadenhöhe (eigene Schätzung)",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: {
                xxl: 4,
              },
              valid: "getValue('grossschaden') === false || isNotEmpty(item)",
            },
            {
              control: "numberinput", //immer 0
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "schaden_kostenvoranschlag",
              label: "Schadenhöhe (Kostenvoranschlag)",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: {
                xxl: 4,
              },
            },
            {
              control: "numberinput", //immer 0
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "schaden_rechnungsbetrag",
              label: "Schadenhöhe (Rechnung)",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: {
                xxl: 4,
              },
            },
            {
              control: "switch",
              name: "schaden_abtretungserklärung",
              label: "Abtretungserklärung liegt vor ja/nein",
              cols: "12",
            },
            {
              control: "switch",
              name: "schaden_totalschaden",
              label: "Totalschaden",
              cols: "12",
            },
            {
              control: "switch",
              name: "schaden_personenschaden",
              label: "eine Person wurde geschädigt",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_beschaedigte_sache",
              label: "Was wurde beschädigt?",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_beschaedigte_teile",
              label: "Welche Teile wurden beschädigt?",
              cols: "12",
            },
            {
              control: "input",
              name: "schaden_verursacher",
              label: "Wer hat den Schaden verursacht? (Name und Anschrift)",
              cols: "12",
            },
            /*{
              control: "textarea",
              name: "schaden_spuren",
              label: "Gibt es Spuren?",
              cols: "12",
            },*/
            {
              control: "switch",
              name: "schaden_vorschaeden",
              label: "Vorschäden",
              cols: "6",
              hidden: "isEqualOther('versicherung_art', 'haftpflicht')",
            },
            {
              control: "switch",
              name: "schaden_vorschaeden_repariert",
              label: "Vorschäden wurden repariert",
              hidden: "isEqualOther('versicherung_art', 'haftpflicht')",
              cols: "6",
            },
            /*{
              control: "input",
              name: "schaden_verursacher",
              label: "Verursacher (Name und Anschrift)",
              cols: "12",
            },
            {
              control: "textarea",
              name: "schaden_betroffene_sachen_behaeltnisse",
              label: "Worin wurden die betroffenen Sachen aufbewahrt?",
              cols: "12",
            },
            {
              control: "switch",
              name: "schaden_behaeltnisse_verschlossen",
              label: "die Behältnisse waren verschlossen",
              cols: "6",
            },
            {
              control: "input",
              name: "schaden_aufbewahrungsort_schluessel",
              label: "Aufbewahrungsort der Schlüssel",
              cols: "12",
              hidden: "isNotEqualOther('schaden_behaeltnisse_verschlossen', true)",
            },
            {
              control: "textarea",
              name: "schaden_oeffnung_behaeltnisse",
              label: "Öffnung der Behältnisse (Beschreibung)",
              cols: "12",
              hidden: "isNotEqualOther('schaden_behaeltnisse_verschlossen', true)",
            },
            {
              control: "upload",
              name: "schaden_oeffnung_behaeltnisse_fotos",
              label: "Fotos der Öffnung der Behältnisse",
              multiple: true,
              add_description: true,
              allowedExtensions: ["GIF", "TIF", "TIFF", "JPG", "JPEG", "PNG", "PDF", "DOC", "DOCX", "XLS", "XLSX", "MSG", "EML"],
              cols: "12",
              hidden: "isNotEqualOther('schaden_behaeltnisse_verschlossen', true)",
            },*/
          ],
        },
        {
          label: "Polizei",
          description:
            "Falls der Unfall polizeilich aufgenommen wurde, benötigen wir weitere Details.",
          children: [
            {
              control: "switch",
              name: "polizei_aufgenommen",
              label: "polizeiliche Aufnahme ist erfolgt",
              cols: 12,
            },
            {
              control: "input",
              name: "polizei_dienststelle",
              label: "Dienststelle",
              cols: "12",
              hidden: "isNotEqualOther('polizei_aufgenommen', true)",
            },
            {
              control: "input",
              name: "polizei_tagebuchnummer",
              label: "Aktzenzeichen/Tagebuchnummer",
              cols: "12",
              hidden: "isNotEqualOther('polizei_aufgenommen', true)",
            },
            {
              control: "switch",
              name: "polizei_alkohol_drogen",
              label: "Konsum von Alkohol oder Drogen",
              cols: 6,
              hidden: "isNotEqualOther('polizei_aufgenommen', true)",
            },
            {
              control: "switch",
              name: "ermittlungsverfahren",
              label: "Ermittlungs- oder Strafverfahren eingeleitet",
              cols: 12,
            },
            {
              control: "input",
              name: "ermittlungsverfahren_behoerde",
              label: "Behörde",
              cols: "6",
              hidden: "isNotEqualOther('ermittlungsverfahren', true)",
            },
            {
              control: "input",
              name: "ermittlungsverfahren_aktenzeichen",
              label: "Aktenzeichen",
              cols: "6",
              hidden: "isNotEqualOther('ermittlungsverfahren', true)",
            },
            {
              control: "switch",
              name: "fahrerflucht",
              label: "Es liegt Fahrerflucht vor",
              cols: 12,
            },
            {
              control: "textarea",
              name: "fahrerflucht_details",
              label: "Nähere Angaben zur Fahrerflucht",
              cols: "12",
              hidden: "isNotEqualOther('fahrerflucht', true)",
            },
          ],
        },
        {
          label: "Fahrzeug",
          description: "",
          children: [
            {
              control: "input",
              name: "fahrzeug_kennzeichen",
              label: "Kennzeichen",
              cols: "4",
            },
            {
              control: "input",
              name: "fahrzeug_marke",
              label: "Marke",
              cols: "4",
            },
            {
              control: "input",
              name: "fahrzeug_modell",
              label: "Modell",
              cols: "4",
            },
            {
              control: "numberinput",
              name: "fahrzeug_km",
              label: "Kilometerstand (km)",
              allow_negative: false,
              cols: "4",
            },
            {
              control: "select",
              name: "fahrzeug_finanzierung",
              label: "Finanzierung des Fahrzeugs",
              cols: "4",
              options: [
                { key: "eigenfinanziert", label: "eigenfinanziert" },
                { key: "Kredit", label: "Kredit" },
                { key: "Leasing", label: "Leasing" },
              ],
            },
            {
              control: "input",
              name: "anhaenger_kennzeichen",
              label: "Kennzeichen Anhänger",
              cols: "4",
            },
            {
              control: "input",
              name: "anhaenger_gesellschaft",
              label: "Anhänger versichert bei (Gesellschaft)",
              cols: "6",
            },
            {
              control: "input",
              name: "anhaenger_vertragsnummer",
              label: "Anhänger Vertragsnummer",
              cols: "6",
            },
          ],
        },

        {
          label: "Fahrer",
          description: "",
          children: [
            {
              control: "select",
              name: "fahrzeug_lenker_typ",
              label: "Fahrzeuglenker zum Schadenzeitpunkt",
              cols: "6",
              options: [
                { key: "Versicherungsnehmer", label: "Versicherungsnehmer" },
                { key: "Fahrzeughalter", label: "Fahrzeughalter" },
                { key: "abweichend", label: "abweichend" },
              ],
            },
            {
              control: "switch",
              name: "fahrt_genehmigt",
              label: "Die Fahrt war vom Versicherungsnehmer genehmigt",
              default: true,
              cols: 6,
            },
            {
              control: "switch",
              name: "fahrer_identisch_halter",
              label: "Fahrer gleichzeitig Fahrzeughalter",
              default: true,
              cols: 12,
            },
            {
              control: "input",
              name: "fahrer_vorname",
              label: "Vorname",
              cols: "6",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_name",
              label: "Nachname",
              cols: "6",
              valid: "isNotEmpty(item)",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_strasse",
              label: "Strasse",
              cols: "8",
              valid: "isNotEmpty(item)",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_hausnummer",
              label: "Hausnummer",
              cols: "2",
              valid: "isNotEmpty(item)",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_land",
              label: "Land",
              cols: "2",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_plz",
              label: "PLZ",
              cols: "4",
              valid: "isNotEmpty(item)",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_ort",
              label: "Ort",
              cols: "8",
              valid: "isNotEmpty(item)",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_telefon_mobil",
              label: "Telefon mobil",
              cols: "6",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_email",
              label: "E-Mail",
              valid: "isNotEmpty(item) && isEmail(item)",
              cols: "6",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_fuehrerschein_klasse",
              label: "Führerscheinklasse",
              cols: "4",
              valid: "isNotEmpty(item)",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "datepicker",
              name: "fahrer_fuehrerschein_ausstellungsdatum",
              label: "Ausstellungsdatum Führerschein",
              cols: "4",
              valid: "isNotEmpty(item)",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "input",
              name: "fahrer_fuehrerschein_nummer",
              label: "Führerscheinnummer",
              cols: "4",
              valid: "isNotEmpty(item)",
              hidden:
                "isEqualOther('fahrer_identisch_halter', true) && isNotEqualOther('fahrzeug_lenker_typ', 'abweichend')",
            },
            {
              control: "switch",
              name: "fahrer_fahrerlaubnis_vorhanden",
              label: "Gültige Fahrerlaubnis für das gefahrene Kfz",
              default: true,
              cols: 12,
            },
            {
              control: "input",
              name: "fahrer_fahrerlaubnis_behoerde",
              label: "Ausstellende Behörde",
              cols: "6",
              hidden: "isNotEqualOther('fahrer_fahrerlaubnis_vorhanden', true)",
            },
            {
              control: "input",
              name: "fahrer_fahrerlaubnis_auflagen",
              label: "Einschränkungen / Auflagen",
              cols: "6",
              hidden: "isNotEqualOther('fahrer_fahrerlaubnis_vorhanden', true)",
            },
          ],
        },
        paymentSection,
        {
          label: "Ansprechpartner",
          description: "",
          children: [
            {
              control: "input",
              name: "ansprechpartner_vorname",
              label: "Vorname",
              cols: "6",
            },
            {
              control: "input",
              name: "ansprechpartner_name",
              label: "Nachname",
              cols: "6",
              valid: "isNotEmpty(item)",
            },
            {
              control: "input",
              name: "ansprechpartner_telefon",
              label: "Telefon",
              cols: "6",
              valid: "isNotEmpty(item)",
            },
            {
              control: "input",
              name: "ansprechpartner_mobil",
              label: "Mobilnummer (wird bevorzugt)",
              cols: "6",
            },
            {
              control: "input",
              name: "ansprechpartner_email",
              label: "E-Mail",
              valid: "isNotEmpty(item) && isEmail(item)",
              cols: "6",
            },
          ],
        },
        {
          label: "Unfallgegner/Geschädigte Person",
          description:
            "Die Frage, 'Was ist passiert?', ist entscheidend, um den Versicherungsschaden korrekt zu bearbeiten. Bitte beschreiben Sie den Vorfall so ausführlich wie möglich. Wo und wann ist er passiert? Welche Umstände haben dazu geführt? Welche Schäden sind aufgetreten? Ihre genaue Beschreibung hilft dem Versicherer, den Schadensfall effizient zu prüfen und die Ansprüche Ihres Mandante zu bearbeiten. Je mehr Informationen Sie bereitstellen, desto besser kann der Versicherer Ihren Schaden prüfen.",
          children: [
            {
              control: "input",
              name: "geschaedigte_person_vorname",
              label: "Vorname",
              cols: "6",
            },
            {
              control: "input",
              name: "geschaedigte_person_name",
              label: "Nachname",
              cols: "6",
              valid: "isNotEmpty(item)",
            },
            {
              control: "input",
              name: "geschaedigte_person_strasse",
              label: "Strasse",
              cols: "8",
              valid: "isNotEmpty(item)",
            },
            {
              control: "input",
              name: "geschaedigte_person_hausnummer",
              label: "Hausnummer",
              cols: "2",
              valid: "isNotEmpty(item)",
            },
            {
              control: "input",
              name: "geschaedigte_person_land",
              label: "Land",
              cols: "2",
            },
            {
              control: "input",
              name: "geschaedigte_person_plz",
              label: "PLZ",
              cols: "4",
              valid: "isNotEmpty(item)",
            },
            {
              control: "input",
              name: "geschaedigte_person_ort",
              label: "Ort",
              cols: "8",
              valid: "isNotEmpty(item)",
            },
            {
              control: "input",
              name: "geschaedigte_person_telefon",
              label: "Telefon",
              cols: "6",
            },
            {
              control: "input",
              name: "geschaedigte_person_email",
              label: "E-Mail",
              valid: "isNotEmpty(item) && isEmail(item)",
              cols: "6",
            },
            {
              control: "input",
              name: "geschaedigte_person_fahrzeug",
              label: "Fahrzeug (Marke, Typ)",
              cols: "4",
            },
            {
              control: "input",
              name: "geschaedigte_person_kennzeichen",
              label: "Kennzeichen",
              valid: "isNotEmpty(item)",
              cols: "4",
            },
            {
              control: "textarea",
              name: "geschaedigte_person_beschaedigte_teile",
              label: "Welche Teile wurden beschädigt?",
              cols: "12",
            },
            {
              control: "textarea",
              name: "geschaedigte_person_art_beschaedigung",
              label: "Art der Beschädigung",
              cols: "12",
            },
            {
              control: "input",
              name: "geschaedigte_person_fahrzeug_standort",
              label: "Aktueller Standort des Kfz",
              cols: "8",
            },
            {
              control: "numberinput",
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "geschaedigte_person_schadenhoehe",
              label: "Geschätzte Schadenhöhe",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: "4",
            },
            {
              control: "switch",
              name: "direktabrechnung",
              label: "Direktabrechnung mit Reparaturfirma",
              cols: "12",
            },
            {
              control: "textarea",
              name: "geschaedigte_person_verletzung_beschreibung",
              label: "Art und Umfang der Verletzung",
              cols: "12",
              hidden: "isNotEqualOther('schaden_personenschaden', true)",
            },
            {
              control: "upload",
              name: "geschaedigte_person_arztbericht",
              label: "Arztbericht",
              multiple: true,
              add_description: true,
              allowedExtensions: [
                "GIF",
                "TIF",
                "TIFF",
                "JPG",
                "JPEG",
                "PNG",
                "PDF",
                "DOC",
                "DOCX",
                "XLS",
                "XLSX",
                "MSG",
                "EML",
              ],
              cols: "12",
              hidden: "isNotEqualOther('schaden_personenschaden', true)",
            },
          ],
        },
        {
          label: "Anhänge",
          description: "",
          children: [
            {
              control: "upload",
              name: "sonstiges_abtretungserklaerung",
              label: "Abtretungserklärung der Werkstatt (RKÜ)",
              multiple: true,
              add_description: true,
              allowedExtensions: [
                "GIF",
                "TIF",
                "TIFF",
                "JPG",
                "JPEG",
                "PNG",
                "PDF",
                "DOC",
                "DOCX",
                "XLS",
                "XLSX",
                "MSG",
                "EML",
              ],
              cols: "12",
            },
            {
              control: "upload",
              name: "sonstiges_unterlagen",
              label:
                "z.B. Farbfotos inkl. Kennzeichen, Kostenvoranschlag, Reparaturrechnung; maximale Größe von 15MB. Ohne Rechnungen und Schadenfotos kann der Schaden nicht zur Prüfung gemeldet werden",
              multiple: true,
              add_description: true,
              allowedExtensions: [
                "GIF",
                "TIF",
                "TIFF",
                "JPG",
                "JPEG",
                "PNG",
                "PDF",
                "DOC",
                "DOCX",
                "XLS",
                "XLSX",
                "MSG",
                "EML",
              ],
              cols: "12",
              valid: "isNotEmpty(item)",
            },
            {
              control: "info",
              title: "Welche Unterlagen haben Sie hochgeladen?",
              description: "Diese Liste dient zur Überprüfung",
            },
            {
              label: "Schadenfotos",
              description:
                "Bitte übermitteln Sie uns Fotos des Schadens. Diese helfen uns, den Schaden schneller und besser zu prüfen.",
              control: "radiogroup",
              name: "schadenfotos",
              cols: "12",
              valid: "isNotEmpty(item)",
              options: [
                {
                  key: "hochgeladen",
                  label: "hochgeladen",
                },
                {
                  key: "Schaden_bereits_behoben",
                  label: "Schaden bereits behoben",
                },
                {
                  key: "Erstellung_nicht_moeglich",
                  label: "Erstellung nicht möglich",
                },
              ],
            },
            {
              label: "Kostenvoranschlag/Rechnung",
              control: "checkbox",
              name: "kostenvoranschlag",
              valid:
                "isEqual(item, true, 'Kostenvoranschlag oder Rechnung sollte hochgeladen werden')",
              default: false,
            },
            {
              label: "Leckortungsbericht",
              control: "checkbox",
              name: "leckortungsbericht",
            },
            {
              label: "Abtretungserklärung",
              control: "checkbox",
              name: "abtretungserklaerung",
            },
          ],
        },
        regulierungSection,
        {
          label: "Abschluß",
          description: "",
          children: [
            {
              control: "switch",
              name: "alles_korrekt",
              label:
                "Die vorstehenden Angaben habe(n) ich/wir wahrheitsgetreu und nach bestem Wissen und Gewissen gemacht. Der Versicherungsnehmer ist für die Richtigkeit der Angaben verantwortlich, auch wenn eine andere Person ihre Niederschrift vornimmt. Bewusst unwahre oder unvollständige Angaben führen auch dann zum Verlust des Versicherungsschutzes, wenn dem Versicherer dadurch kein Nachteil entsteht. Der Versicherer ist bevollmächtigt, bei Behörden in alle diesen Vorfall betreffenden Akten einzusehen und ggf. Abschriften anzufertigen. Wir sind damit einverstanden, dass die Abwicklung ohne vorherige Information ggf. direkt mit den Geschädigten erfolgen kann.",
              cols: 12,
              valid: "isEqual(item, true, 'Die Bestätigung ist verpflichtend')",
            },
          ],
        },
      ],
    },
  ],
  transformIn: [
    /*{
			fn: "copyIfEmpty",
			source: "bezeichnung",
			target: "schaden_ort",
		},
		{
			fn: "copyIfEmpty",
			source: "bezeichnung",
			target: "schaden_besichtigung_adresse",
		},*/
    {
      fn: "copyIfEmpty",
      source: "user.vorname",
      target: "ansprechpartner_vorname",
    },
    {
      fn: "copyIfEmpty",
      source: "user.nachname",
      target: "ansprechpartner_name",
    },
    {
      fn: "copyIfEmpty",
      source: "user.telefon",
      target: "ansprechpartner_telefon",
    },
    {
      fn: "copyIfEmpty",
      source: "user.email",
      target: "ansprechpartner_email",
    },
  ],
  transformOut: [
    {
      fn: "setConst",
      target: "docx_template",
      value: "B_KFZ_Schaden",
    },
  ],
};
